var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarO(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52448 1.08116C7.67416 0.620534 8.32583 0.620532 8.47552 1.08116L9.54529 4.37316C9.74612 4.99115 10.322 5.40956 10.9718 5.40958L14.4333 5.40971C14.9176 5.40973 15.119 6.0295 14.7271 6.31421L11.9268 8.34891C11.4012 8.73087 11.1812 9.40787 11.382 10.0259L12.4515 13.318C12.6011 13.7786 12.0739 14.1616 11.6821 13.877L8.88163 11.8425C8.35592 11.4606 7.64408 11.4606 7.11837 11.8425L4.31792 13.877C3.92606 14.1616 3.39885 13.7786 3.5485 13.318L4.61803 10.0259C4.8188 9.40787 4.59883 8.73087 4.07315 8.34891L1.27285 6.31421C0.881022 6.02951 1.0824 5.40973 1.56674 5.40971L5.02819 5.40958C5.67799 5.40956 6.25388 4.99115 6.45471 4.37316L7.52448 1.08116Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarO);
export default __webpack_public_path__ + "static/media/star-o.f663f5efc58245f2ca585a65e7626581.svg";
export { ForwardRef as ReactComponent };